import { Helpers } from "../../../../helpers/Helpers";
import { GetAntrepoOutByIdResponseData } from "../../../../models/response/antrepoOut/GetAntrepoOutByIdResponse";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";

interface Props {
    transferAntrepoOutsRef: any
    transferAntrepoOuts: GetAntrepoOutByIdResponseData[]
}

const TransferAntrepoOuts = ({
    transferAntrepoOutsRef,
    transferAntrepoOuts
}: Props) => {
    return (
        <div className='containerPart' ref={transferAntrepoOutsRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Devir Antrepo Çıkışı</h4>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th>Çıkış Antrepo Beyan No</th>
                                            <th>Çıkış Antrepo Beyan Tarihi</th>
                                            <th>Beyan Kap Adet</th>
                                            <th>Beyan Kap Ağırlık (Kg)</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            transferAntrepoOuts.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            transferAntrepoOuts.map((item, index) =>
                                                <tr>
                                                    <td><a onClick={() => window.open(window.location.href.split('=')[0].replace('antrepoin', 'antrepoout') + "=" + item.antrepoOutId, "_blank")} href='javascript:;'>{item.antrepoDeclarationNo}</a></td>
                                                    <td>{item.antrepoDeclarationDateStr}</td>
                                                    <td>{item.declarationPotQuantity}</td>
                                                    <td>{item.declarationPotWeight}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default TransferAntrepoOuts;